import { ChangeDetectionStrategy, Component, computed, input, output, viewChild, viewChildren } from '@angular/core';
import { MatMenu, MatMenuItem, MatMenuModule } from '@angular/material/menu';

import { ModuleIconComponent } from '@shared/components/module-icon/module-icon.component';

import { MenuItem } from '@models/menu';
import { MenuFlyoutFitDirective } from '@system/menu/common/menu-flyout-fit.directive';
import { isMenuFolder } from '../common/menu-item.utils';

@Component({
  selector: 'app-menu-flyout',
  templateUrl: './menu-flyout.component.html',
  imports: [MatMenuModule, ModuleIconComponent, MenuFlyoutComponent, MenuFlyoutFitDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuFlyoutComponent {
  private static _idSeq = 0;

  readonly headerId = `menu-flyout-header-${MenuFlyoutComponent._idSeq++}`;

  items = input<MenuItem[]>([]);
  label = input<string>('');
  iconId = input<number>();
  color = input<string>();
  activeId = input<number>();

  itemClick = output<MenuItem>();

  menu = viewChild(MatMenu);
  flyoutMenuItems = viewChildren<MatMenuItem>('flyoutMenuItem');

  visibleItems = computed(() =>
    (this.items() ?? []).filter(item => !item.hidden && (!isMenuFolder(item) || item.children?.some(c => !c.hidden))),
  );

  focusActiveItem(): void {
    const activeItemIndex = this.visibleItems().findIndex(item => item.id === this.activeId());
    if (activeItemIndex >= 0) {
      this.flyoutMenuItems()[activeItemIndex]?.focus('program');
    }
  }

  readonly isMenuFolder = isMenuFolder;
}
